import {auth0Plugin} from "~/utils/auth0";

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(auth0Plugin)
})